import view from '@shared/components/layout-default/layout-default-router-view';
import apiV1 from '@/modules/integration/pages/api/api';
import apiV2 from '@/modules/integration/pages/api_v2/api';

const pages_v1 = [
  {
    path: 'v1',
    component: apiV1,
    children: [
      {
        path: 'general',
        name: 'integration.api.general',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/general')
      },
      {
        path: 'user',
        name: 'integration.api.user',
        component: () => import(/* webpackChunkName: "integration" */ '@integration/pages/api/user')
      },
      {
        path: 'sms',
        name: 'integration.api.sms',
        component: () => import(/* webpackChunkName: "integration" */ '@integration/pages/api/sms')
      },
      {
        path: 'get-state',
        name: 'integration.api.get-state',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/get-state')
      },
      {
        path: 'database',
        name: 'integration.api.database',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/database')
      },
      {
        path: 'group-database',
        name: 'integration.api.group-database',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/group-database')
      },
      {
        path: 'statistic',
        name: 'integration.api.statistic',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/statistic')
      },
      {
        path: 'phones',
        name: 'integration.api.phones',
        component: () =>
          import(/* webpackChunkName: "integration" */ '@integration/pages/api/phones')
      }
    ]
  }
];

const doc = [
  {
    name: 'general',
    title: 'Что такое ZORRA API?',
  },
  { name: 'token', title: 'Обновление токена' },
  { name: 'user', title: 'Информация о пользователе' },
  { name: 'sms', title: 'SMS рассылки' },
  { name: 'verification', title: 'Верификация номеров' },
  { name: 'databases', title: 'Базы данных' },
  { name: 'hlr', title: 'HLR запросы' }
];
const pages_v2 = [
  {
    path: 'v2',
    component: apiV2,
    children: doc.map((i) => ({
      path: i.name,
      name: `integration.api_v2.${i.name}`,
      component: () =>
        import(/* webpackChunkName: "integration" */ `@integration/pages/api_v2/${i.name}`)
    }))
  }
];

export const integration = [
  {
    path: '/integration',
    component: view,
    children: [...pages_v1, ...pages_v2]
  }
];
